<template>
  <h1 class="d-flex flex-column gap-2">View BOL page</h1>
</template>
